import { useQuery } from "@tanstack/react-query";
import { apiClient } from "zodios/client";
import type { TranscriptsSchema } from "zodios/apiDefinitions/api/transcripts";
import Loading from "components/core/blocks/Loading";
import { Container as Grid } from "react-bootstrap";
import { useAppSelector } from "redux/hooks";
import TranscriptTable from "modules/tclip/TranscriptTable";
import { DevErrorDisplay } from "components/core/blocks/DevErrorDisplay";
import Breadcrumb from "components/core/blocks/Breadcrumb";
import { DASHBOARD_LINKS } from "utils/dashboardLinks";

const extractRelationIdFromHash = (hash: string): string => {
  const hashParams = new URLSearchParams(hash.substring(1));
  return hashParams.get("relation") || "";
};

const FetchTranscripts = () => {
  const relationId = extractRelationIdFromHash(window.location.hash);

  const getDashboardTo = () => {
    const url = `/user/tclip/transcripts`;

    return url;
  };

  const breadCrumbItems = [
    {
      name: "Communications",
      href: getDashboardTo(),
      dropdownLinkOptions: DASHBOARD_LINKS,
      unsorted: true,
      searchable: false,
      dropdownSubtitle: "Dashboards",
    },
  ];

  const orgId = useAppSelector((state) => state.user.organization_id);
  const transcriptQuery = useQuery<TranscriptsSchema>({
    queryKey: ["transcripts", orgId, relationId],
    queryFn: async () => {
      const params: { relation_id: string | number | boolean; org_id: string } = {
        relation_id: relationId || "",
        org_id: orgId,
      };
      return await apiClient.getTranscripts({
        params,
      });
    },
  });
  if (transcriptQuery.isPending) {
    return <Loading fullPage={false} height={300} />;
  }
  if (transcriptQuery.error) {
    return <DevErrorDisplay userMessage={"Error loading transcripts"} error={transcriptQuery.error} />;
  }
  const allTranscripts = transcriptQuery.data;

  return (
    <div>
      {allTranscripts && (
        <Grid
          fluid
          style={{
            minHeight: "calc(100vh - 150px)",
            background: "#fefefe",
          }}
        >
          <Breadcrumb items={breadCrumbItems} />
          <TranscriptTable transcripts={[allTranscripts]} />
        </Grid>
      )}
    </div>
  );
};

export default FetchTranscripts;
